// src/app/oferta-detalle/oferta-detalle.component.ts
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EstadoOfertaCredito } from 'src/app/models/enum/estado-oferta-credito';
import {  OfertaCredito } from 'src/app/models/oferta-credito.model';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-oferta-detalle',
  templateUrl: './oferta-detalle.component.html',
  styleUrls: ['./oferta-detalle.component.css']
})
export class OfertaDetalleComponent implements OnInit {
  oferta!: OfertaCredito;
  solicitudCreditoId!: string;
  ofertaId!: string;

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.solicitudCreditoId = this.route.snapshot.paramMap.get('solicitudId')!;
    this.ofertaId = this.route.snapshot.paramMap.get('ofertaId')!;
    this.loadOferta();
  }

  loadOferta(): void {
    this.dataService.getData(`solicitud-credito/${this.solicitudCreditoId}/ofertas/${this.ofertaId}`).subscribe({
      next: (data: OfertaCredito) => {
        this.oferta = data;
      },
      error: (error: any) => {
        console.error('Error al cargar la oferta', error);
      },
      complete: () => {
        console.log('Carga de oferta completada');
      }
    });
  }

  cambiarEstado(nuevoEstado: any): void {
    this.dataService.updateData({ nuevoEstado }, `solicitud-credito/${this.solicitudCreditoId}/ofertas/${this.ofertaId}/estado`).subscribe({
      next: () => {
        console.log(`Oferta ${nuevoEstado} con éxito`);
      },
      error: (error: any) => {
        console.error(`Error al ${nuevoEstado} la oferta`, error);
      },
      complete: () => {
        this.router.navigate(['/home']);
      }
    });
  }
}
